import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

import Card from 'components/Card'

export const CardContainer = styled(Card)`
  padding: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`

export const TableContainer = styled.table`
  min-width: 100%;
  border-collapse: collapse;
  border-radius: ${({ theme }) => theme.radii.default};
`

export const TableHeader = styled.thead`
  background-color: ${({ theme }) => theme.colors.grays.N050};
  border-bottom: 2px solid ${({ theme }) => theme.colors.grays.N300};
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grays.N200};

  :last-child {
    border-bottom: none;
  }
`

export const TableCell = styled.td`
  padding: 6px 8px;
  text-align: ${props => (props.align ? props.align : 'left')};
  white-space: nowrap;
  font-size: 14px;
  line-height: 19px;

  ${props =>
    props.as === 'th' &&
    css`
      color: ${props.theme.colors.grays.N600};
      text-transform: uppercase;
      font-size: 12px;
      line-height: 16px;
    `};
`

TableCell.propTypes = {
  width: PropTypes.string,
}

TableCell.defaultProps = {
  width: 'auto',
}
